module.exports = __webpack_public_path__ + "media/images/illusration-car-and-teacher-a2191bd0987d763943cae0c502e6b7d5.png";